import { EXAMPLE_DATA_DEFAULTCODE, POPUP_ENRICH_DATA_TRACKING_CODE } from '../../Constants'
import sendTrackingData from '../../Functions/sendTrackingData'
import { getTrackingId, validateEmailRegex } from '../../Utils'
import { fetchMiniGameData, validateEmail, submitMinigame } from '../../Services'
import { shouldShowPopup } from '../../Functions/shouldShowPopup'
import { closePopup, showPopup } from '../../Functions/sendTrackingEvents'
import { generateResultPage } from './ResultPage'
import { generateMinimize } from './Minimize'
import { generateMainContent } from './MainContent'

const clearAll = () => {
  document.getElementById('kariba_overlay_container')?.remove()
  document.getElementById('kariba_result_container_result_defaultcode')?.remove()
  document.getElementById('kariba_default_code')?.remove()
  document.getElementById('kariba_default_code_minimize')?.remove()
}

const showMinimized = () => {
  let minimized = document.getElementById('kariba_default_code_minimize')
  minimized.className = 'show-class'
}

const hideMinimized = () => {
  let minimized = document.getElementById('kariba_default_code_minimize')
  minimized.className = 'hide-class'
}

const showOverlay = () => {
  let overlayLayer = document.getElementById('kariba_overlay_container')
  overlayLayer.className = 'show-class'
}

const hideOverlay = (node_uuid) => {
  let overlayLayer = document.getElementById('kariba_overlay_container')
  overlayLayer.className = 'hide-class'
  closePopup(node_uuid, clearAll)
}

const showResultPage = (data, node_uuid, inputValue) => {
  const trackingId = getTrackingId()

  const html = generateResultPage(data)
  const isConfetti = data?.background?.effects == 'Confetti'
  let fireworks

  document.getElementById('kariba_overlay_container')?.remove()

  sendTrackingData(POPUP_ENRICH_DATA_TRACKING_CODE, {
    node_uuid,
    email: inputValue?.value,
    utm_s: data?.email?.emailData?.utm_source,
    utm_m: data?.email?.emailData?.utm_medium,
    utm_c: data?.email?.emailData?.utm_campaign,
    coupon: data?.mainPopup?.default_coupon?.code,
    popup_type: 2, // 'random_gift' -> 1 | 'default_code' -> 2 | 'spin_game' -> 3
  })

  const valueSubmit = {
    node_uuid,
    tracking_id: trackingId,
    coupon_code: data?.mainPopup?.default_coupon?.code,
    email: inputValue?.value,
  }

  const mess = submitMinigame(valueSubmit)

  document.body.innerHTML += html

  let resultPage = document.getElementById('kariba_result_container_result_defaultcode')
  if (resultPage) {
    if (isConfetti) {
      const canvas = document.getElementById('kariba_effect_canvas')
      const myConfetti = confetti.create(canvas, { resize: true, useWorker: true })
      myConfetti({ particleCount: 100, spread: 160 })
    } else {
      const wrapper = document.getElementById('effect_wrapper')
      fireworks = new Fireworks(wrapper)
      fireworks.start()
    }
  }

  let continueShoppingBtn = document.getElementById('kariba_continue_shopping')

  continueShoppingBtn.addEventListener('click', () => {
    clearAll()
    if (!isConfetti && fireworks) fireworks.stop()
  })
}

const showInvalidEmail = (errMesg) => {
  let alertEmail = document.getElementById('alert_email')
  alertEmail.style.display = 'block'
  alertEmail.textContent = errMesg || 'Email không hợp lệ'
}

const hideInvalidEmail = () => {
  let alertEmail = document.getElementById('alert_email')
  alertEmail.style.display = 'none'
}

const checkEmail = async (emailInput, node_uuid) => {
  const isEmailValidate = validateEmailRegex(emailInput)

  if (!isEmailValidate) {
    showInvalidEmail()
    return false
  }

  try {
    const resp = await validateEmail(emailInput?.value, node_uuid)
    if (resp.status === 200) {
      hideInvalidEmail()
      return true
    } else {
      showInvalidEmail(resp?.msg?.detail)
      return false
    }
  } catch (error) {
    showInvalidEmail()
    return false
  }
}

export const generateDefaultCode = (resp) => {
  // console.log('resp: ', resp)
  if (!resp) return
  if (!shouldShowPopup(resp?.node_uuid)) return
  const mainPopupData = resp.data.mainPopup
  const minimizeData = resp.data.minimize
  const resultData = resp.data.result

  const minimizeHTML = generateMinimize(resp?.data?.minimize)
  document.body.innerHTML += minimizeHTML

  const mainContentHTML = generateMainContent(mainPopupData)
  document.body.innerHTML += mainContentHTML
  showPopup(resp?.node_uuid)

  let minimizeButton = document.getElementById('kariba_default_code_minimize')
  minimizeButton.addEventListener('click', () => {
    hideMinimized()
    showOverlay()
  })

  let closeDefaultCode = document.getElementById('kariba_close_default_code')
  closeDefaultCode.addEventListener('click', () => {
    showMinimized()
    hideOverlay(resp?.node_uuid)
  })

  const emailInput = document.getElementById('kariba_minigame_email')
  let showResultPageDC = document.getElementById('receive_voucher')
  showResultPageDC.addEventListener('click', async () => {
    hideInvalidEmail()
    const isEmailValid = await checkEmail(emailInput, resp?.node_uuid)
    if (!isEmailValid) return
    showResultPage(resp.data, resp?.node_uuid, emailInput)
  })
}
